
const _columns = [
  {
    key: 'users',
    name: 'benefits_users_table_header_employee',
    visible: true,
    modifiable: false,
    template: '198px',
    entity: ['RF', 'BS']
  },
  {
    key: 'subvention_status',
    name: 'benefits_users_table_header_subvention_status',
    visible: true,
    modifiable: true,
    template: 'minmax(120px,130px)',
    entity: ['BS']
  },

  {
    key: 'restaurants_status',
    name: 'benefits_users_table_header_meals_activated',
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    superAdminOnly: false,
    entity: ['RF']
  },
  {
    key: 'restaurants_current_assigned',
    name: null,
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'restaurants_next_month_assigned',
    name: 'benefits_users_table_header_meals_next_months',
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'restaurants_spent_vs_available',
    name: 'benefits_users_table_header_spent_vs_available',
    visible: true,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'transport_status',
    name: 'benefits_users_table_header_transport_activated',
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    superAdminOnly: false,
    entity: ['RF']
  },
  {
    key: 'transport_current_assigned',
    name: null,
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'transport_next_month_assigned',
    name: 'benefits_users_table_header_transport_next_months',
    visible: true,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'transport_spent_vs_available',
    name: 'benefits_users_table_header_spent_vs_available',
    visible: true,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'nursery_status',
    name: 'benefits_users_table_header_nursery_status',
    visible: false,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    superAdminOnly: true,
    entity: ['RF']
  },
  {
    key: 'nursery_current_assigned',
    name: 'benefits_users_table_header_nursery_assignation',
    visible: false,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'insurance_status',
    name: 'benefits_users_table_header_insurance_status',
    visible: false,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    superAdminOnly: true,
    entity: ['RF']
  },
  {
    key: 'insurance_current_assigned',
    name: 'benefits_users_table_header_insurance_assignation',
    visible: false,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'insurance_policy_holder',
    name: 'benefits_users_table_header_insurance_policy_holders',
    visible: false,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'insurance_disabled_policy_holders',
    name: 'benefits_users_table_header_insurance_disabled_policy_holders',
    visible: false,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  },
  {
    key: 'education_status',
    name: 'benefits_users_table_header_insurance_education_status',
    visible: false,
    modifiable: true,
    template: 'minmax(120px, 130px)',
    superAdminOnly: true,
    entity: ['RF']
  },

  {
    key: 'education_current_assigned',
    name: 'benefits_users_table_header_insurance_education_assignation',
    visible: false,
    modifiable: true,
    template: 'minmax(130px, 140px)',
    entity: ['RF', 'BS']
  }

]
export const retFlexColumns = _columns.filter(el => el.entity.includes('RF'))

const __columnsVisibleInBs = [
  'subvention_status',
  'restaurants_current_assigned',
  'restaurants_next_month_assigned',
  'restaurants_spent_vs_available',
  'transport_current_assigned',
  'transport_next_month_assigned',
  'transport_spent_vs_available',
  'nursery_current_assigned',
  'insurance_current_assigned',
  'insurance_policy_holder',
  'insurance_disabled_policy_holders',
  'education_current_assigned'
]

export const subventionColumns = _columns.filter(el => el.entity.includes('BS')).map(el => {
  if (__columnsVisibleInBs.includes(el.key)) {
    let column = { ...el }
    column.visible = true
    return column
  } else {
    return el
  }
})
